import React from 'react';
import cx from 'classnames';
import _map from 'lodash/map';
import _get from 'lodash/get';
import _findIndex from 'lodash/findIndex';
import _lowercase from 'lodash.lowercase';
import { FormattedMessage } from 'react-intl';
import Link from 'components/Link';
import withLocation from 'helpers/withLocation';
import MODELS from 'constants/asicModels';
import Transition from 'components/Transition';
import style from './AsicModelSwitch.module.css';

const getLeftValue = (fromAsic, activeAsic, asics) => {
  if (!fromAsic) {
    return 0;
  }

  const fromAsicIndex = _findIndex(asics, item => _get(item, 'key') === fromAsic);
  const activeAsicIndex = _findIndex(asics, item => _get(item, 'key') === activeAsic);

  const distanceBetweenFromAndActive = fromAsicIndex - activeAsicIndex;

  if (distanceBetweenFromAndActive === 0) {
    return '0';
  }

  return `${distanceBetweenFromAndActive * 100}%`;
}

const AsicModelSwitch = ({ location, ...props }) => {
  return (
     <section className={style.root}>
      {_map(MODELS, (item, key) => {
        const path = `/asic/${_lowercase(key).replace(/\s/g, '')}`
        return (
          <Link
            withLang
            key={key}
            className={cx(style.btn, { [style.active]: key === props.selected })}
            to={path}
            state={{ fromAsic: props.selected }}
          >
            <span className={style.btnTitle}>{item.title}</span>
            <br/>
            <span className={style.btnCaption}>{item.fullTitle}</span>
            <br/>
            {item.hashrate && (
              <span className={style.btnBigCaption}>
                <FormattedMessage id="AsicModelSwitch.upTo" defaultMessage="Up to" />
                {' '}
                {item.hashrate}
              </span>
            )}
            <Transition
              defaultStyle={{
                transition: 'left 0.3s ease-in-out',
                left: getLeftValue(_get(location, 'state.fromAsic'), props.selected, Object.values(MODELS)),
                top: '100%',
                position: 'absolute',
                width: '100%',
              }}
              transitionStyles={{
                entering: { left: '0%' },
                entered: { left: '0%' },
                exiting: { left: getLeftValue(_get(location, 'state.fromAsic'), props.selected, Object.values(MODELS)) },
              }}
              transitionTime={300}
            >
              <div className={style.triangleActive}></div>
            </Transition>
          </Link>
        );
      })}
    </section>
  );
}

export default withLocation(AsicModelSwitch);
